import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import DidYouKnowTour from './onboarding/DidYouKnowTour';
import HeaderAgro from "./HeaderAgro"
import HeaderPastoral from "./HeaderPastoral"
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import PubZone from "./PubZone"
import Footer from "./Footer"
import TopHeader from './TopHeader';
import useCurrencyReferential from '../hooks/useCurrencyReferential';
import ChatbotWidget from './chatbot/ChatbotWidget';

const Layout = () => {

  const domain_type = useSelector((state) => state.domain.domain, shallowEqual);
  // Référentiel pays → devise du backend commercial, pour toutes les pages.
  useCurrencyReferential();
    useEffect(() => {
    }, [domain_type]);
  return (
    <>
        <TopHeader />
        {domain_type === "agro" ? <HeaderAgro /> : <HeaderPastoral />}
        <PubZone />
        <DidYouKnowTour />
        <Outlet />
        <Footer />
        <ChatbotWidget />
    </>
  )
};
export default Layout;
